import { Controller } from '@hotwired/stimulus'

// Fills the sidebar's notifications context. Fetched every time the pane is
// shown, so the list never goes stale while the page stays open.
export default class extends Controller {
  static targets = ['list']
  static values = { url: String, icons: Object }

  connect() {
    this._onShown = (e) => {
      if (e.target.getAttribute('href') === `#${this.element.id}`) this.load()
    }
    document.addEventListener('shown.bs.tab', this._onShown)
  }

  disconnect() {
    document.removeEventListener('shown.bs.tab', this._onShown)
    this._abort?.abort()
  }

  load() {
    this._abort?.abort()
    this._abort = new AbortController()
    this._message(this.listTarget.dataset.loadingText)

    fetch(this.urlValue, { headers: { Accept: 'application/json' }, signal: this._abort.signal })
      .then((r) => r.json())
      .then((items) => this._render(items))
      .catch((e) => {
        if (e.name !== 'AbortError') this._message(this.listTarget.dataset.failedText)
      })
  }

  _message(text) {
    this.listTarget.replaceChildren()
    if (!text) return
    const p = document.createElement('p')
    p.className = 'menu-flat-empty'
    p.textContent = text
    this.listTarget.appendChild(p)
  }

  _render(items) {
    this.listTarget.replaceChildren()
    if (!items.length) return this._message(this.listTarget.dataset.emptyText)

    for (const item of items) {
      const a = document.createElement('a')
      a.className = 'menu-flat-item'
      a.href = item.href
      if (item.unread) a.dataset.unread = ''

      const icon = document.createElement('span')
      icon.className = 'menu-flat-item-icon'
      icon.dataset.severity = item.severity
      const svg = this.iconsValue?.[item.severity]
      if (svg) icon.innerHTML = svg
      a.appendChild(icon)

      const body = document.createElement('span')
      body.className = 'menu-flat-item-body'
      const subject = document.createElement('span')
      subject.className = 'menu-flat-item-label notification-subject-line'
      subject.textContent = item.subject
      body.appendChild(subject)
      const time = document.createElement('span')
      time.className = 'menu-flat-item-path'
      time.textContent = item.time
      body.appendChild(time)
      a.appendChild(body)

      if (item.unread) {
        const dot = document.createElement('span')
        dot.className = 'menu-flat-item-dot'
        a.appendChild(dot)
      }

      this.listTarget.appendChild(a)
    }
  }
}
